// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export class environment
{
  constructor(){}

   getServerUrl() : string
   {
      let result = "";

        if (window.location.href.indexOf("localhost") > 0)
        {
          result = "http://localhost/Ecoembes.SGS.GestionUsuariosExternos.MiddleWare/";
        }
        else
        {
          let indexEcoembes = window.location.href.indexOf("Ecoembes.SGS");
          result = window.location.href.substr(0, indexEcoembes) + "Ecoembes.SGS.GestionUsuariosExternos.MiddleWare/";
        }

      return result;
   }

   getUrlPortal() : string 
   {
      //const url = "https://presistemas.ecoembes.com/Ecoembes.SGS.GestionUsuariosExternos.WebUI/AltaUsuarios?areaprivadaempresas"; //Para pruebas pasamos directamente la url 
      let result = "";

      if (window.location.href.indexOf("?areaprivadaempresas") > 0)
        {
          result = "https://areaprivadaempresas-api.ecoembes.com/user/login";
        }
      else if (window.location.href.indexOf("/sistemas") > 0)
        {
          result = "https://aplicaciones.ecoembes.com/Ecoembes.SGC.ServiciosPortal.WebUI/SingleSignOn.aspx";
        }
      else
        result = "https://preaplicaciones.ecoembes.com/Ecoembes.SGC.ServiciosPortal.WebUI/SingleSignOn.aspx";

      return result;
   }
}



// export const environment = {
//   production: false,
//   API_Url: 'http://localhost/Ecoembes.SGS.GestionUsuariosExternos.MiddleWare/'
// };

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
